import { Link } from "react-router";

import { useAccount } from "../lib/account.ts";
import { WorkspaceShell } from "../workspace/WorkspaceShell.tsx";
import { PATHS, ROUTE_COPY } from "./routes.constants.ts";
import "../workspace/workspace.css";

/**
 * An address that matches nothing.
 *
 * Offers the chooser rather than the sign-in page: whoever is reading this is
 * more likely to have mistyped a workspace URL than to be signed out, and the
 * chooser bounces them onward if they are.
 */
export function NotFound() {
  const { signOut } = useAccount();

  return (
    <WorkspaceShell onSignOut={signOut}>
      <h1 className="workspace__title">{ROUTE_COPY.notFoundTitle}</h1>
      <p className="workspace__note">{ROUTE_COPY.notFound}</p>
      <Link className="workspace__apply" to={PATHS.workspaces}>
        {ROUTE_COPY.notFoundAction} <span aria-hidden="true">→</span>
      </Link>
    </WorkspaceShell>
  );
}
